// extracted by mini-css-extract-plugin
module.exports = {"molecule__tag-input-container":"styles_molecule__tag-input-container__7ixCP","spin":"styles_spin__Dh1BN","pulse-up-and-down":"styles_pulse-up-and-down__9DkCE"};